export default {
    created: "Campania WhatsApp a fost creata cu succes.",
    updated: "Campania WhatsApp a fost actualizata cu succes.",
    deleted: "Campania WhatsApp a fost stearsa cu succes.",
    restored: "Campania WhatsApp a fost restaurata cu succes.",
    sent: "Campania WhatsApp a fost trimisa cu succes.",
}
